<template>
    <div class="live-script" :class="{ 'live-script--mobile-stack': layoutMobileStack }">
        <div class="container">
            <div class="head-box">
                <img class="decorate" src="~assets/image/student/live/scriptLeftDecorate.png" />
                <div class="title">直播带货脚本</div>
                <img class="decorate" src="~assets/image/student/live/scriptRightDecorate.png" />
                <el-button type="text" class="font-size-setting-btn" @click="openFontSizeDialog">字幕字号</el-button>
            </div>
            <div class="content" ref="contentRef" :style="contentDynamicStyle">
                <template v-if="scriptData.length > 0">
                    <el-scrollbar style="height: 100%; flex: 1" v-if="liveState == 0">
                        <not-start-script :scriptData="scriptData"></not-start-script>
                    </el-scrollbar>
                    <div v-else class="live-ing-script">
                        <span class="text">{{ currentScript.script_content }}</span>
                    </div>
                </template>
                <template v-else>
                    <div class="empty">无脚本信息</div>
                </template>
            </div>
        </div>
        <el-dialog
            title="设置字幕字号"
            :visible.sync="fontSizeDialogVisible"
            width="360px"
            append-to-body
            :close-on-click-modal="false"
        >
            <el-input v-model="fontSizeInput" placeholder="请输入字号（像素）" clearable />
            <span slot="footer" class="dialog-footer">
                <el-button @click="fontSizeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmFontSize">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import NotStartScript from "./liveScript/NotStartScript";
export default {
    name: "LiveScript",
    data() {
        return {
            fontSizeDialogVisible: false,
            fontSizeInput: "",
            /** 用户确认后的字幕内容区字号（px），null 表示沿用样式表默认 */
            customContentFontSize: null,
        };
    },
    props: {
        scriptData: {
            type: Array,
            default: () => [],
        },
        liveState: {
            type: Number,
            default: 0,
        },
        currentScript: {
            type: Object,
            default: () => {},
        },
        /** 手机宫格布局：直播中脚本区字号与行高 */
        layoutMobileStack: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        packList() {
            return this.scriptData;
        },
        contentDynamicStyle() {
            if (this.customContentFontSize == null) {
                return {};
            }
            const lh = this.customContentFontSize + 5;
            return {
                fontSize: `${this.customContentFontSize}px`,
                lineHeight: `${lh}px`,
                "--live-script-live-font-size": `${this.customContentFontSize}px`,
                "--live-script-live-line-height": `${lh}px`,
            };
        },
    },
    components: {
        NotStartScript,
    },
    methods: {
        /** 打开字号弹窗：输入框默认取当前内容区实际显示字号 */
        openFontSizeDialog() {
            this.fontSizeDialogVisible = true;
            this.$nextTick(() => {
                this.fontSizeInput = String(this.readDisplayedContentFontSizePx());
            });
        },
        /** 从 DOM 读取当前脚本内容区用于展示的正文字号（px） */
        readDisplayedContentFontSizePx() {
            if (this.customContentFontSize != null) {
                return this.customContentFontSize;
            }
            const root = this.$refs.contentRef;
            if (!root || typeof window === "undefined") {
                return this.layoutMobileStack ? 16 : 24;
            }
            const liveText = root.querySelector(".live-ing-script .text");
            const snippetText = root.querySelector(".script-snippet-item .text");
            const target = liveText || snippetText || root;
            const px = parseInt(window.getComputedStyle(target).fontSize, 10);
            return Number.isNaN(px) ? (this.layoutMobileStack ? 16 : 24) : px;
        },
        /** 确认修改字号并关闭弹窗 */
        confirmFontSize() {
            const n = parseInt(String(this.fontSizeInput).trim(), 10);
            if (Number.isNaN(n) || n < 8 || n > 120) {
                this.$message.warning("请输入 8～120 之间的整数字号");
                return;
            }
            this.customContentFontSize = n;
            this.fontSizeDialogVisible = false;
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.live-script {
    box-sizing: border-box;
    flex: 6;
    font-size: 14px;
    color: #fff;
    background-color: #0c0e3f;
    .container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        .head-box {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100px;
            width: 100%;
            font-size: 24px;
            .font-size-setting-btn {
                position: absolute;
                top: 10px;
                right: 10px;
                padding: 0 8px;
                color: #9eb4ff;
                font-size: 14px;
            }
            .title {
                margin: 0 24px;
                margin-top: -2px;
            }
            .decorate {
                width: 41px;
                height: 15px;
                vertical-align: middle;
            }
        }
        .content {
            position: relative;
            flex: 1;
            display: flex;
            justify-content: center;
            overflow: hidden;
            .live-ing-script {
                box-sizing: border-box;
                display: flex;
                align-items: center;
                width: 85%;
                height: 100%;
                font-size: var(--live-script-live-font-size, 24px);
                line-height: var(--live-script-live-line-height, 72px);
                letter-spacing: 1px;
                word-break: break-all;
                overflow: hidden;
                .text {
                    transform: translateY(-30px);
                }
            }
            .empty {
                position: absolute;
                top: 40%;
                font-size: 20px;
                color: #aaa;
            }
        }
    }
}

/* 手机宫格：脚本过长时在内容区纵向滑动查看 */
.live-script.live-script--mobile-stack {
    min-height: 0;

    .container {
        min-height: 0;
    }

    .container .content {
        box-sizing: border-box;
        min-height: 0;
        padding: 20px;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        touch-action: pan-y;
        overscroll-behavior: contain;
        justify-content: flex-start;
        align-items: center;
    }

    .container .content .live-ing-script {
        font-size: var(--live-script-live-font-size, 16px);
        line-height: var(--live-script-live-line-height, 20px);
        height: auto;
        min-height: min-content;
        max-height: none;
        overflow: visible;
        align-items: flex-start;
        padding: 12px 0 16px;

        .text {
            transform: translateY(0);
            display: block;
        }
    }
}

::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
}
</style>
